module.exports = __webpack_public_path__ + "static/img/qrcode.95d44195.png";